/**
 * Component: VIN Prompt
 * ------------------------------------------------------------------------------
 * A message to hide and show based on the Current Car state.
 * - Requires the `vin-prompt.liquid` snippet.
 *
 * @namespace VinPrompt
 */
import log from 'salvo-lite/log'
import Cookies from 'js-cookie'
import cssClasses from '../helpers/cssClasses'
import {on} from '../helpers/utils'

class VinPrompt {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            closeButton: '[data-vin-prompt-close]',
            ...JSON.parse(elem.getAttribute('data-vin-prompt') || '{}')
        }

        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            closeButton: document.querySelector(this._settings.closeButton)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._checkCookieForCarSet()
        this._setEventBusListeners()
    }

    /**
     * Checks if there is a cookie for the car being set
     */
    _checkCookieForCarSet () {
        if (Cookies.get('Current_Car')) {
            this._elem.classList.remove(cssClasses.active)
        } else {
            this._elem.classList.add(cssClasses.active)
        }
    }

    /**
     * Checks if there is a cookie being set for the car
     */
    _setEventBusListeners () {
        window.Frame.EventBus.listen([
            'CurrentCar:updated',
            'CurrentCar:cleared'
        ], () => this._checkCookieForCarSet())

        on('click', this._nodeSelectors.closeButton, () => {
            this._elem.classList.remove(cssClasses.active)
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // })
}

export default VinPrompt



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VinPrompt.js